import type { Expert } from '../types/expert';

export function formatAED(value: number): string {
  return `AED ${value.toLocaleString('en-US')}`;
}

export function formatCompact(value: number): string {
  return new Intl.NumberFormat('en-US', { notation: 'compact', maximumFractionDigits: 1 }).format(value);
}

export function formatDate(iso: string): string {
  return new Date(iso).toLocaleDateString('en-GB', { day: 'numeric', month: 'short', year: 'numeric' });
}

export function getInitials(name: string): string {
  return name
    .replace(/^Dr\.\s*/, '')
    .split(' ')
    .filter((p) => p.length > 2 || p === p.toUpperCase())
    .slice(0, 2)
    .map((p) => p[0])
    .join('')
    .toUpperCase();
}

export function engagementCount(expert: Expert): number {
  return expert.events.filter((e) => e.status !== 'Upcoming').length;
}

export function totalPaid(expert: Expert): number {
  return expert.events.filter((e) => e.status === 'Paid').reduce((sum, e) => sum + e.fee, 0);
}

export function pendingAmount(expert: Expert): number {
  return expert.events.filter((e) => e.status === 'Pending').reduce((sum, e) => sum + e.fee, 0);
}

export function averageRating(expert: Expert): number {
  if (expert.reviews.length === 0) return 0;
  const sum = expert.reviews.reduce((s, r) => s + r.rating, 0);
  return Math.round((sum / expert.reviews.length) * 10) / 10;
}

export function scoreLabel(score: number): string {
  if (score >= 85) return 'Excellent';
  if (score >= 70) return 'Strong';
  if (score >= 50) return 'Moderate';
  return 'Low';
}

export function scoreColor(score: number): string {
  if (score >= 85) return 'text-emerald-600';
  if (score >= 70) return 'text-sky-600';
  if (score >= 50) return 'text-amber-600';
  return 'text-red-600';
}
